/* ==========================================================================
   CREATIVE DETONATOR - Sequence Controller
   Phase timeline management for method pages
   Location: frontend/js/method/sequence.js
   ========================================================================== */

const SequenceController = {
  phases: [],
  completedCount: 0,
  timerInterval: null,
  timerSeconds: 0,
  timerRunning: false,

  init() {
    this.phases = document.querySelectorAll('.phase-item');
    this.timerDisplay = document.querySelector('.timer-digits');
    this.startBtn = document.querySelector('.timer-btn-start');
    this.resetBtn = document.querySelector('.timer-btn-reset');
    this.timelineLine = document.querySelector('.timeline-line-progress');
    this.summaryRows = document.querySelectorAll('.summary-row[data-phase]');

    this.bindEvents();
    this.updateProgress();
  },

  bindEvents() {
    // Phase status buttons - mark as done
    this.phases.forEach((phase, index) => {
      const statusBtn = phase.querySelector('.phase-status');
      const marker = phase.querySelector('.phase-marker');

      if (statusBtn) {
        statusBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.togglePhase(phase, index);
        });
      }

      if (marker) {
        marker.addEventListener('click', () => {
          this.togglePhase(phase, index);
        });
      }
    });

    // Task checkboxes
    document.querySelectorAll('.phase-tasks li').forEach(task => {
      task.addEventListener('click', () => {
        task.classList.toggle('checked');
        this.playClickSound();
      });
    });

    // Timer controls
    if (this.startBtn) {
      this.startBtn.addEventListener('click', () => this.toggleTimer());
    }

    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', () => this.resetTimer());
    }
  },

  togglePhase(phase, index) {
    const statusBtn = phase.querySelector('.phase-status');
    const marker = phase.querySelector('.phase-marker');
    const isCompleted = phase.classList.contains('completed');

    if (isCompleted) {
      phase.classList.remove('completed');
      if (statusBtn) statusBtn.classList.remove('done');
      if (statusBtn) statusBtn.textContent = 'PENDING';
      if (marker) marker.classList.remove('completed');
    } else {
      phase.classList.add('completed');
      if (statusBtn) statusBtn.classList.add('done');
      if (statusBtn) statusBtn.textContent = 'DONE';
      if (marker) marker.classList.add('completed');
      this.playClickSound();
    }

    this.updateProgress();
  },

  updateProgress() {
    const completed = document.querySelectorAll('.phase-item.completed');
    this.completedCount = completed.length;

    // Update timeline progress line
    if (this.timelineLine) {
      const progress = (this.completedCount / this.phases.length) * 100;
      this.timelineLine.style.height = progress + '%';
    }

    // Update summary rows
    this.summaryRows.forEach((row, index) => {
      const phaseNum = parseInt(row.dataset.phase);
      const phaseItem = document.querySelector(`.phase-item:nth-child(${phaseNum})`);
      if (phaseItem && phaseItem.classList.contains('completed')) {
        row.classList.add('completed');
      } else {
        row.classList.remove('completed');
      }
    });

    // Check for all complete
    if (this.completedCount === this.phases.length) {
      this.playSuccessSound();
    }
  },

  toggleTimer() {
    if (this.timerRunning) {
      this.pauseTimer();
    } else {
      this.startTimer();
    }
  },

  startTimer() {
    this.timerRunning = true;
    if (this.startBtn) {
      this.startBtn.textContent = 'PAUSE';
      this.startBtn.classList.add('active');
    }
    if (this.timerDisplay) {
      this.timerDisplay.classList.add('running');
    }

    this.timerInterval = setInterval(() => {
      this.timerSeconds++;
      this.updateTimerDisplay();
    }, 1000);
  },

  pauseTimer() {
    this.timerRunning = false;
    if (this.startBtn) {
      this.startBtn.textContent = 'START';
      this.startBtn.classList.remove('active');
    }
    if (this.timerDisplay) {
      this.timerDisplay.classList.remove('running');
    }

    clearInterval(this.timerInterval);
  },

  resetTimer() {
    this.pauseTimer();
    this.timerSeconds = 0;
    this.updateTimerDisplay();
  },

  updateTimerDisplay() {
    if (!this.timerDisplay) return;

    const hours = Math.floor(this.timerSeconds / 3600);
    const minutes = Math.floor((this.timerSeconds % 3600) / 60);
    const seconds = this.timerSeconds % 60;

    const pad = (n) => n.toString().padStart(2, '0');
    this.timerDisplay.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  },

  playClickSound() {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = 600;
      osc.type = 'square';
      gain.gain.value = 0.1;
      osc.start();
      gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.08);
      osc.stop(ctx.currentTime + 0.08);
    } catch(e) {}
  },

  playSuccessSound() {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const notes = [392, 523, 659, 784]; // G4, C5, E5, G5
      notes.forEach((freq, i) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.frequency.value = freq;
        osc.type = 'square';
        gain.gain.value = 0.08;
        osc.start(ctx.currentTime + i * 0.12);
        gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + i * 0.12 + 0.15);
        osc.stop(ctx.currentTime + i * 0.12 + 0.15);
      });
    } catch(e) {}
  }
};

// Auto-init when DOM ready and page type matches
document.addEventListener('DOMContentLoaded', () => {
  if (document.body.dataset.methodPage === 'sequence') {
    SequenceController.init();
  }
});

// Export for external use
window.SequenceController = SequenceController;
